export default __webpack_public_path__ + "static/media/Kmal Solar.32daa504.png";